export default (editor, config = {}) => {
  const bm = editor.BlockManager
  const { accordionBlock } = config
  const { style } = config
  const type = 'accordion'
  const content = `<div data-gjs-type="${type}"></div>
    ${style ? `<style>${style}</style>` : ''}`

  accordionBlock && bm.add(type, {
    label: `
      <div class="d-flex flex-column align-center justify-center">
        <i class="v-icon notranslate material-icons theme--light" style="font-size: 36px;">expand_more</i>
        <div class="overline">Accordion</div>
      </div>
    `,
    category: 'Basic',
    content,
    ...accordionBlock
  })
}